import React from 'react'
import SectionLabel from '../SectionLabel/SectionLabel'
import Styles from '../Content/Content.css'
import Button from '../Button/Button'

const Get = () => {
  return (
    <section className="md:pt-20 md:pb-20 pt-10 pb-10">
      <div className="container">
        <div className="flex max-md:flex-col pt-2">
          <div>
            <div className="font-color-arizona-blue">
              <h2 className="text-3xl font-extrabold condensed">{'What You Get'}</h2>
              <p className="text-xl pt-2 font-semibold">
                {'This honors education comes with serious perks.'}
              </p>
            </div>
            <div>
              <ul className="perks md:pl-12  pl-8 pt-4 font-color-arizona-blue">
                <li>Top faculty and intimate classes</li>
                <li>Priority class registration</li>
                <li>Graduate library privileges</li>
                <li>
                  <a
                    href="https://frankehonors.arizona.edu/academics/early-assurance-programs"
                    target="_blank"
                    linkID="early-assurance"
                    className="red-link"
                  >
                    Early assurance programs
                  </a>{' '}
                  for the Colleges of Medicine and Veterinary Medicine
                </li>
                <li>
                  Honors study abroad to Costa Rica, Spain, Italy,{' '}
                  <a
                    linkId="and-more"
                    href="https://frankehonors.arizona.edu/student-experience/study-abroad"
                    target="_blank"
                    className="red-link"
                  >
                    {' '}
                    and more
                  </a>
                </li>
                <li>Exclusive majors, minors, and certificate programs</li>
                <li>Scholarships and research funding</li>
                <li>Graduate with honors</li>
              </ul>
            </div>
            <p className="pt-4 font-color-arizona-blue">… and that’s just the beginning.</p>

            <div className="get-button-wrap md:pb-6 pt-6 flex max-md:justify-center">
              <Button
                linkId="student-experience"
                className="border-white"
                link="https://frankehonors.arizona.edu/student-experience/franke-honors-experience"
              >
                Student Experience
              </Button>
            </div>
            <div className="p-6 max-md:pl-0 mt-6 get-banner text-white relative font-bold">
              <p>
                Follow Etan on his busy day, from a pancake breakfast at the Honors Village to a
                solar oven competition.
              </p>
            </div>
            <div className="pt-8 hidden md:block font-color-arizona-blue">
              <p>
                Did you know it’s possible to earn honors credit for non-honors courses?{' '}
                <a
                  linkId="here-is-how"
                  className="red-link"
                  href="https://frankehonors.arizona.edu/academics/honors-contracts"
                  target="_blank"
                >
                  Here’s how.
                </a>
              </p>
            </div>
          </div>
          <div className="basis-1/2 relative short-container h-fit">
            <div className="video-container3">
              <iframe
                width="368"
                height="560"
                src="https://youtube.com/embed/Xw_JkVkxJD0?si=LRDNyIijjVC1ZQf4"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            <div className="watch-more-button flex justify-center p-2 pb-4">
              <Button
                linkId="watch-more"
                className="border-white"
                link="https://youtube.com/playlist?list=PLMrsYOKrP2J-V3MG4acBPhA4--r34_xWo&si=bO7q3xOExhnXIlbd"
              >
                Watch More
              </Button>
            </div>
          </div>
          <div className="pt-6  max-md:block md:hidden font-color-arizona-blue">
            <p>
              Did you know it’s possible to earn honors credit for non-honors courses?{' '}
              <a
                linkId="here-is-how"
                className="red-link"
                href="https://frankehonors.arizona.edu/academics/honors-contracts"
                target="_blank"
              >
                Here’s how.
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Get
